// extracted by mini-css-extract-plugin
module.exports = {"HeaderHeight":"110px","AnnouncementHeight":"40px","SidebarWidth":"330px","wrapper":"src-modules-composer-components-nodeControl---wrapper---3ghwl"};